import { render, staticRenderFns } from "./task-upload.vue?vue&type=template&id=c1a2db9c&scoped=true&"
import script from "./task-upload.vue?vue&type=script&lang=js&"
export * from "./task-upload.vue?vue&type=script&lang=js&"
import style0 from "./task-upload.vue?vue&type=style&index=0&id=c1a2db9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a2db9c",
  null
  
)

export default component.exports